// extracted by mini-css-extract-plugin
module.exports = {"wrap":"j_bs","phone":"j_bt","phone-link":"j_bv","phoneLink":"j_bv"};